import React from 'react';
import Beton from './beton.svg';
import Union from './union.svg';
import Zenit from './zenit.svg';

export const BetonMobile = () => (
  <div className="header-wrapper__partnerLogo-wrapper">
    <div className="header-wrapper__beton">
      <div className="header-wrapper__beton-zenit">
        <img src={Zenit} alt="" />
      </div>
      <div className="header-wrapper__beton-cross">
        <img src={Union} alt="" />
      </div>
      <div className="header-wrapper__beton-beton">
        <img src={Beton} alt="" />
      </div>
    </div>
  </div>
);
